import { useAuth0 } from '@auth0/auth0-react';
import { Avatar } from '@mui/material';

const UserAvatar = ({ onClick }: { onClick: () => void }) => {
  const { user } = useAuth0();
  return (
    <Avatar
      src={user?.picture}
      sx={{
        width: { desktop: '50px', tablet: '40px' },
        height: { desktop: '50px', tablet: '40px' },
        marginTop: { mobile: '24px', tablet: '24px', desktop: '20px' },
        marginRight: { mobile: '16px', tablet: '24px', desktop: 0 },
        transition: '0.3s ease',
        '&:hover': {
          boxShadow: '0 0 0 3px #6C727A30',
          cursor: 'pointer',
        },
      }}
      onClick={onClick}
    />
  );
};

export default UserAvatar;
